var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2501 78.8337H53.7501C71.6667 78.8337 78.8334 71.667 78.8334 53.7503V32.2503C78.8334 14.3337 71.6667 7.16699 53.7501 7.16699H32.2501C14.3334 7.16699 7.16675 14.3337 7.16675 32.2503V53.7503C7.16675 71.667 14.3334 78.8337 32.2501 78.8337Z",
    stroke: "#009FBD",
    strokeWidth: 5.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7084 43.0003C62.7084 53.8937 53.8934 62.7087 43.0001 62.7087C32.1067 62.7087 25.4776 51.7437 25.4776 51.7437M25.4776 51.7437H34.3642M25.4776 51.7437V61.5978M23.2917 43.0003C23.2917 32.107 32.0351 23.292 43.0001 23.292C56.1509 23.292 62.7084 34.257 62.7084 34.257M62.7084 34.257V24.4028M62.7084 34.257H53.9651",
    stroke: "#009FBD",
    strokeWidth: 5.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/Refresh_Icon.54fe8d201a71f2f5305197a3cc87df57.svg";
export { ForwardRef as ReactComponent };